import { useQuery } from '@tanstack/react-query';

import { DOMJSON } from '../pendoAnnouncments.types';

const useGetPendoAnnouncementDomJson = (url: string) => {
  const getDomJson = async (): Promise<DOMJSON> => {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }

    return response.json();
  };

  return useQuery({
    queryKey: ['pendo-announcement-dom-json', url],
    queryFn: getDomJson,
  });
};

export { useGetPendoAnnouncementDomJson };
